import React, { useRef, useState } from 'react';
import axios from 'axios';
const ContactDetailsSection = () => {
  const form = useRef();
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
  
    const sendMessage = async (e) => {
      e.preventDefault();
      setSubmitted(false);
      setError('');
  
      const formData = new FormData(form.current);
      const data = Object.fromEntries(formData.entries());
  
      try {
  await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, data);
        setSubmitted(true);
        form.current.reset();
      } catch (err) {
        setError('Something went wrong. Please try again.');
      }
    };

  return (
    <div className="container-fluid contact overflow-hidden py-5">
      <div className="container py-5">
        <div className="row g-5 mb-5">
          {/* Left Side - Contact Info */}
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            <div className="sub-style">
              <h5 className="sub-title text-primary pe-3">Quick Contact</h5>
            </div>
            <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
              Have Questions? Don't Hesitate to Contact Us
            </h1>

            <div className="d-flex border-bottom mb-4 pb-4">
              <i className="fas fa-map-marked-alt fa-4x text-primary bg-light p-3 rounded"></i>
              <div className="ps-3">
                <h5 style={{ color: "#A71717" }}>Location</h5>
                <p>ICT Park, Addis Ababa.</p>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-xl-6">
                <div className="d-flex">
                  <i className="fas fa-tty fa-3x text-primary"></i>
                  <div className="ps-3">
                    <h5 className="mb-3" style={{ color: "#A71717" }}>Quick Contact</h5>
                    <div className="mb-3">
                      <h6 className="mb-0" style={{ color: "#A71717" }}>Phone:</h6>
                      <a href="#" className="text-muted me-0">
                        <i className="fas fa-phone-alt text-secondary me-2"></i>
                        +251 909 434470, +251 913 897665
                      </a>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0" style={{ color: "#A71717" }}>Email:</h6>
                      <a href="#" className="fs-5 text-primary">info@yodbusiness.com</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="d-flex">
                  <i className="fas fa-clone fa-3x text-primary"></i>
                  <div className="ps-3">
                    <h5 className="mb-3" style={{ color: "#A71717" }}>Opening Hrs</h5>
                    <div className="mb-3">
                      <h6 className="mb-0" style={{ color: "#A71717" }}>
                        24/7 Every Day (Monday-Monday)
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center pt-3">
              <div className="me-4">
                <div
                  className="bg-light d-flex align-items-center justify-content-center"
                  style={{ width: 90, height: 90, borderRadius: 10 }}
                >
                  <i className="fas fa-share fa-3x text-primary"></i>
                </div>
              </div>
              <div className="d-flex">
                <a className="btn btn-secondary border-secondary me-2 p-0" href="">
                  facebook <i className="fas fa-chevron-circle-right"></i>
                </a>
                <a className="btn btn-secondary border-secondary mx-2 p-0" href="">
                  twitter <i className="fas fa-chevron-circle-right"></i>
                </a>
                <a className="btn btn-secondary border-secondary mx-2 p-0" href="">
                  instagram <i className="fas fa-chevron-circle-right"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="300">
            <div className="sub-style">
              <h5 className="sub-title text-primary pe-3">Let’s Connect</h5>
            </div>
            <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>Send Your Message</h1>

    <form ref={form} onSubmit={sendMessage}>
      <div className="mb-3">
        <input 
          type="text" 
          name="user_name" 
          className="form-control" 
          placeholder={'Enter your name or company'} 
          required 
        />
      </div>
      <div className="mb-3">
        <input 
          type="email" 
          name="user_email" 
          className="form-control" 
          placeholder={'Enter a valid email'} 
          required 
        />
      </div>
      <div className="mb-3">
        <input 
          type="text" 
          name="phone_no" 
          className="form-control" 
          placeholder={'Enter your phone number'} 
          required 
        />
      </div>
      <div className="mb-3">
        <textarea 
          name="message" 
          rows="4" 
          className="form-control" 
          placeholder={'Enter your message'} 
          required
        ></textarea>
      </div>
      <button type="submit" className="btn btn-danger w-100">
        {'Submit'}
      </button>
    </form>
  </div>

  {submitted && (
    <div className="alert alert-success mt-4" role="alert">
      ✅ {'Thank you! Your message has been sent.'}
    </div>
  )}
    
      {error && (
        <div className="alert alert-danger mt-4" role="alert">
          ❌ {error}
        </div>
      )}
          </div>
        </div>
      </div>
        );
};

export default ContactDetailsSection;
